import { useState } from "react";
import { Dialog } from "@mui/material";
import intl from "react-intl-universal";
import { TbCopy, TbKey } from "react-icons/tb";
import { ModalCloseButton } from "../../../../../Components/Molecules/ValutDialog";
import { useToast } from "../../../../../Hooks/toast";

export const BaasApiKeyRevealModal = ({
  open,
  onClose,
  fullKey = null,
  keyName = "",
  loading = false,
  error = null,
}) => {
  const { addToast } = useToast();
  const [copyError, setCopyError] = useState(null);

  const handleClose = () => {
    setCopyError(null);
    onClose();
  };

  const handleCopy = async () => {
    if (!fullKey) return;
    try {
      await navigator.clipboard.writeText(fullKey);
      setCopyError(null);
      addToast({
        type: "success",
        title: intl.get("baas.api.keys.copied"),
      });
    } catch {
      setCopyError(intl.get("baas.processing.copyError"));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ className: "!rounded-2xl !shadow-card" }}
    >
      <div className="relative px-5 py-6 sm:px-6">
        <ModalCloseButton onClick={handleClose} className="absolute right-3 top-3" disabled={loading} />
        <div className="flex items-center gap-3 pr-8">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#e7a73f]/15">
            <TbKey className="h-5 w-5 text-[#a66f1d]" />
          </div>
          <div>
            <h2 className="text-lg font-bold text-brand-dark dark:text-gray-100">
              {intl.get("baas.api.keys.revealTitle")}
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              {keyName
                ? intl.get("baas.api.keys.revealSubtitleNamed", { name: keyName }) ||
                  intl.get("baas.api.keys.revealSubtitle")
                : intl.get("baas.api.keys.revealSubtitle")}
            </p>
          </div>
        </div>

        {loading ? (
          <p className="mt-5 text-sm text-gray-500 dark:text-gray-400">
            {intl.get("baas.api.keys.revealLoading")}
          </p>
        ) : null}

        {error || copyError ? (
          <p
            role="alert"
            className="mt-4 rounded-xl border border-red-200 bg-red-50/80 px-4 py-3 text-sm text-red-700 dark:border-red-900/50 dark:bg-red-950/30 dark:text-red-300"
          >
            {error || copyError}
          </p>
        ) : null}

        {fullKey && !loading ? (
          <div className="mt-5 rounded-xl border border-amber-200 bg-amber-50/80 p-4 dark:border-amber-900/40 dark:bg-amber-950/20">
            <p className="text-xs font-medium text-amber-800 dark:text-amber-300">
              {intl.get("baas.api.keys.revealWarning")}
            </p>
            <div className="mt-3 flex items-center gap-2">
              <code className="min-w-0 flex-1 break-all rounded-lg bg-white px-3 py-2 text-xs text-brand-dark dark:bg-brand-dark-elevated dark:text-gray-100">
                {fullKey}
              </code>
              <button type="button" className="btn-outline !h-9 !min-h-9 !px-3" onClick={handleCopy}>
                <TbCopy className="h-4 w-4" />
              </button>
            </div>
          </div>
        ) : null}

        <div className="mt-6 flex justify-end">
          <button type="button" className="btn-primary" onClick={handleClose} disabled={loading}>
            {intl.get("words.close")}
          </button>
        </div>
      </div>
    </Dialog>
  );
};
